import React from 'react';
import styles from './StatCard.module.css';

interface StatCardProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  value: string | number;
  additionalContent?: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({
  icon,
  title,
  description,
  value,
  additionalContent,
}) => {
  return (
    <div className={styles.statCard}>
      <div className={styles.statCardContent}>
        {icon && (
          <div className={styles.statCardIconWrapper}>
            <div className={styles.statCardIcon}>
              <div className={styles.statCardIconBg}>
                {icon}
              </div>
            </div>
          </div>
        )}
        <div className={styles.statCardText}>
          <div className={styles.statCardTitle}>{title}</div>
          {description && (
            <div className={styles.statCardSubtitle}>{description}</div>
          )}
          {additionalContent}
        </div>
      </div>
      <div className={styles.statCardValue + " innocode-typography--title-md innocode-typography--bold"}>{value}</div>
    </div>
  );
};

